import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared.module';
import { AppLayoutModule } from '@app/app-layout/app-layout.module';
import { QrCodeComponent } from 'ng-qrcode';
import { TabNavigationComponent, TotpManualSetupComponent } from '@component-library/layout';
import { MfaSetupComponent } from './mfa-setup.component';
import { AuthenticatorAppMfaHelpComponent } from '@auth-n/mfa-setup/authenticator-app-mfa-help/authenticator-app-mfa-help.component';
import { SmsMfaConfigurationComponent } from './sms-mfa-configuration/sms-mfa-configuration.component';

@NgModule({
  imports: [
    SharedModule,
    AppLayoutModule,
    QrCodeComponent,
    TabNavigationComponent,
    TotpManualSetupComponent,
    AuthenticatorAppMfaHelpComponent,
    SmsMfaConfigurationComponent
  ],
  declarations: [MfaSetupComponent],
  exports: [MfaSetupComponent]
})
export class MfaSetupModule {}
